/**
 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
 */

import App from './App';

/**
 * App module exports
 */
export { App as default };



// WEBPACK FOOTER //
// ./src/js/App/index.js